import * as React from "react";

import { cn } from "@/lib/utils";
import { scrollIntoViewWithOffset } from "@/lib/scroll-into-view-with-offset";

function Input(
  { className, type, value, onChange, onFocus, ...props }: React.ComponentProps<"input">,
  ref: React.Ref<HTMLInputElement>
) {
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    scrollIntoViewWithOffset(e.currentTarget);
    onFocus?.(e);
  };

  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      value={value}
      onChange={onChange}
      onFocus={handleFocus}
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-sm shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive aria-invalid:text-destructive",
        className
      )}
      {...props}
    />
  );
}

const InputWithRef = React.forwardRef(Input);

export { InputWithRef as Input };
